<template>
  <div>
    <SeedJung_Header></SeedJung_Header>
    <section id="home" class="home text-right">
      <div class="overlay">
        <div class="container">
          <div class="row">
            <div class="col-sm-8 col-sm-offset-4">
              <div class="main_home_content">
                <div class="single_home">
                  <div class="main_home wow fadeInUp" data-wow-duration="700ms">
                    <h1 class="mobile-heading" style="color:white">시드정 이외에도</h1>
                    <h2 class="mobile-heading_2" style="color:blanchedalmond">방법은 있습니다</h2><br />
                    <h2 class="mobile-heading_2" style="color:white"><span style="color:blanchedalmond">다만 도울 수 있습니다</span></h2>
                    <div class="video_play_icon">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="service" class="service">
      <div class="container">
        <div class="row">
          <a href="#service" class="service_border_raund text-center">
            <!-- <img src="assets/images/downicon.png" alt="" /> -->
          </a>
          <div class="main_service_area sections text-center">
            <div class="head_title text-center">
              <h2>MEANING</h2>
              <div class="separator"></div>
              <p class="mobile-paragraph">"시드정"이라는 이름은 마음의 씨앗과 정신의 힘을 상징합니다. <br/>"시드"는 씨앗이나 발아 가능성을 의미하고, "정"은 지혜와 깊은 이해를 나타냅니다. <br/>"시드정"은 우리가 함께 걷는 여정에서 새로운 가능성을 발견하고, 지혜롭게 성장해나가는 곳을 의미합니다.<br/> 함께하는 과정에서 마음의 씨앗을 심고, 이해와 지지를 주고받으며, 새로운 삶의 가능성을 모색하는 공간으로서 시드정이 탄생하게 되었습니다.</p>
            </div>
            <!-- 데스크톱 레이아웃 -->
            <div v-if="!isMobile" class="desktop-layout">
              <div class="col-sm-4">
                <a href="about" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-seedling"></i>
                      </span>
                    </div>
                    <h3>시드정 소개</h3>
                  </div>
                </a>
              </div>
              <div class="col-sm-4">
                <a href="counselor" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-user-friends"></i>
                      </span>
                    </div>
                    <h3>상담사 소개</h3>
                  </div>
                </a>
              </div>
              <div class="col-sm-4">
                <a href="https://blog.naver.com/shabet_naru/223782303803" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-blog"></i>
                      </span>
                    </div>
                    <h3>블로그</h3>
                  </div>
                </a>
              </div>
            </div>
            <!-- 모바일 레이아웃 -->
            <div v-else class="mobile-layout">
              <div class="mobile-services">
                <a href="about" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-seedling"></i>
                      </span>
                    </div>
                    <h3>시드정 소개</h3>
                  </div>
                </a>
                <a href="counselor" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-user-friends"></i>
                      </span>
                    </div>
                    <h3>상담사 소개</h3>
                  </div>
                </a>
                <a href="https://blog.naver.com/shabet_naru/223782303803" class="service-link">
                  <div class="single_service">
                    <div class="service_icon">
                      <span class="icon-circle">
                        <i class="fas fa-blog"></i>
                      </span>
                    </div>
                    <h3>블로그</h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue'

export default {
  name: 'SeedJung_Main',
  props: {
    msg: String
  },
  components: {
    SeedJung_Header
  }
}
</script>

<style scoped>
.service-link {
  display: block;
  text-decoration: none;
  color: inherit;
  margin-bottom: 30px;
}

.single_service {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 30px 20px;
  transition: all 0.3s ease;
}

.service_icon {
  margin-bottom: 20px;
}

.icon-circle {
  padding-left: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  color: white;
  font-size: 30px;
  transition: all 0.3s ease;
}

.service-link:hover .single_service {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.service-link:hover .icon-circle {
  
}

@media (max-width: 767px) {
  .mobile-heading {
    font-size: 32px;
    line-height: 1.0; 
  }
  
  .mobile-heading_2 {
    font-size: 26px;
    line-height: 1.0; 
  }

  body {
    font-size: 16px;
    line-height: 1.4;
  }

  .main_service_area .row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 0 -10px;               
  }
  
  .main_service_area .col-sm-4 {
    flex: 0 0 calc(33.333% - 20px);
    max-width: calc(33.333% - 20px);
    padding: 0 10px;
    margin-bottom: 20px;
  }

  .single_service {
    padding: 15px 10px;
  }

  .icon-circle {
    width: 60px;
    height: 60px;
  }

  .icon-circle i {
    padding-left:3px;
    font-size: 24px;
  }

  h3 {
    font-size: 14px;
  }

  .service-link {
    margin-bottom: 0;
  }


}

@media (max-width: 480px) {
  .main_service_area .row {
    flex-wrap: wrap;
  }

  .main_service_area .col-sm-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.head_title{
    margin-bottom:30px;
}
</style>